/* @ngInject */
function TrashController ($scope, $translate, $state, $location, $stateParams, RepositoryService, ToastService) {
  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId
  $scope.hasShowMoreButton = false
  $scope.currentPage = 'trash'
  $scope.emptyState = {
    imgPath: 'empty-state-used-in',
    title: $translate.instant('repository.emptyState.archive.title'),
    message: $translate.instant('repository.emptyState.archive.message')
  }

  $scope.filters = {
    type: null,
    extension: null
  }
  $scope.pagination = {
    $top: 30,
    $skip: 0
  }

  $scope.sections = [
    { slug: 'folders', assets: [], totalCount: 0 },
    { slug: 'materials', assets: [], totalCount: 0 }
  ]

  let title = ''

  const api = {
    _loadAssets,
    _loadFolders,
    _hasMoreResults,
    _setHeader,
    _searchAssets,
    _clearSearch,
    _successLoadAssets,
    _resetAllSections,
    _successGetFolderById,
    _errorGetFolderById
  }

  this.getApi = () => api

  function activate () {
    $scope.initialLoad = true
    const folderId = $stateParams.id || null

    if (folderId) {
      RepositoryService.getFolderById(folderId, true)
        .then(api._successGetFolderById)
        .catch(api._errorGetFolderById)
    }

    const view = RepositoryService.getView()
    if (view) {
      $location.search({ view })
    } else if ($stateParams.view) {
      $location.search({ view: $stateParams.view })
      RepositoryService.setView($stateParams.view)
    }

    api._loadFolders(true, folderId)
      .then(() => {
        api._loadAssets(folderId)
          .then(() => {
            $scope.initialLoad = false
          })
      })
  }

  activate()

  function _successGetFolderById (folder) {
    if (!folder) {
      ToastService.defaultErrorToast()
      $state.go($state.go('repository.trash'))
    }
  }

  function _errorGetFolderById () {
    ToastService.defaultErrorToast()
  }

  $scope.handleOpenFolder = (folder) => {
    $state.go('repository.trashFolder', {
      id: folder.id
    })
  }

  $scope.loadAssets = api._loadAssets

  $translate.onReady(() => {
    title = $translate.instant('repository.sidebarSections.trash')
    api._setHeader()
  })

  $scope.$watchCollection('headerToolbar.repositoryFilter.params', (fileTypes) => {
    if ($scope.initialLoad) {
      return
    }

    let fileType = null

    for (const type in fileTypes) {
      if (fileTypes[type]) {
        fileType = type
        break
      }
    }

    $scope.filters.type = fileType
    $scope.filters.extension = null

    api._resetAllSections()
    api._loadAssets()
  })

  const deregisterExtensionFilterUpdate = $scope.$on('repository-filters.extension-filter-update', (e, extension) => {
    if ($scope.initialLoad) {
      return
    }

    $scope.filters.extension = extension

    api._resetAllSections()
    api._loadAssets()
  })

  $scope.$on('$destroy', () => {
    deregisterExtensionFilterUpdate()
  })

  $scope.$watch('assetSearch', function () {
    if ($scope.initialLoad) {
      return
    }

    api._resetAllSections()
    api._loadAssets()
  })

  function _resetAllSections () {
    $scope.$broadcast('repository.load-assets-start')
    $scope.hasShowMoreButton = false
    $scope.pagination.$skip = 0
    $scope.sections[1].assets = []
  }

  function _loadAssets (folderId = null) {
    return RepositoryService.getTrashAssets({
      $top: $scope.pagination.$top,
      $skip: $scope.pagination.$skip,
      $sort: 'updatedAt',
      $order: 'ASC',
      search: $scope.assetSearch,
      filters: $scope.filters,
      folderId
    }).then(api._successLoadAssets)
  }

  function _loadFolders (isArchived = true, parentId = null) {
    return RepositoryService.getFolders(parentId, isArchived)
      .then(folders => {
        $scope.sections[0].assets = folders.rows
        $scope.sections[0].totalCount = folders.count
      })
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return Number(totalCount) > responseLength
  }

  function _setHeader () {
    const headerInfo = RepositoryService.getHeader($scope.searching, title, { searchAssets: api._searchAssets, clearSearch: api._clearSearch })

    if ($scope.filters.type) {
      headerInfo.headerToolbar.repositoryFilter.params.all = false
      headerInfo.headerToolbar.repositoryFilter.params[$scope.filters.type] = true
    }

    $scope.headerToolbar = headerInfo.headerToolbar
    $scope.headerNavigation = headerInfo.headerNavigation
    $scope.headerTitle = headerInfo.headerTitle
  }

  function _searchAssets (term) {
    if (!term) {
      api._clearSearch()
      return
    }

    $scope.sections.forEach(section => {
      section.searchedAssets = []
      section.searchedCount = null
    })

    $scope.searching = !!term
    $scope.assetSearch = term
    api._setHeader()
  }

  function _clearSearch () {
    $scope.searching = false
    api._setHeader()
    $('.header .deskfy-header uds-input-search').attr('value', null)

    $scope.assetSearch = ''
  }

  function _successLoadAssets (assets) {
    $scope.pagination.$skip = $scope.pagination.$skip += $scope.pagination.$top
    $scope.sections[1].assets = $scope.sections[1].assets.concat(assets.rows)
    $scope.sections[1].totalCount = assets.count
    $scope.hasShowMoreButton = api._hasMoreResults(assets.count, $scope.sections[1].assets.length)

    $scope.$broadcast('repository.load-assets-end')
  }
}

export { TrashController }
